import React, { useEffect, useRef, useState } from 'react'
import './sessionerror.scss'
import alert from '../../../assets/images/timeout-icon.png'
import { useTranslation } from 'react-i18next';
import { RESOURCE } from '../../../const/resource';
const SessionError = (props: any) => {
    const [num, setNum] = useState(60);
    let intervalRef = useRef<any>();
    const decreaseNum = () =>
    { 
        if (num > 0) {
        setNum((prev) => prev - 1);
        }
    }
    const { t } = useTranslation();
    useEffect(() => {
        intervalRef.current = setInterval(decreaseNum, 1000);
        return () => clearInterval(intervalRef.current);
    }, []);

    return (
        <div className="Sessionmodal">
            <div className="sessionmodal-content">
                <div className='row'>
                    <div className='col-lg-3 col-md-3 col-sm-3 col-3'>
                        <img src={alert} alt={"error"} />
                    </div>
                    <div className='col-lg-9 col-md-9 col-sm-9 col-9 mb-2'>
                        <div className='sessionHeader'>{t(RESOURCE.Myk_Label_SessionHeading)}</div>
                        <div className='sessionSubHeader mt-1'>{t(RESOURCE.Myk_Label_SessionMessage).replace("<num>", num?.toString())}</div>
                        <div className='sessionSubHeader mt-1'>{t(RESOURCE.Myk_Label_SessionQuestion)}</div>
                    </div>
                </div>
                <div className='sessionmodal-btns'>
                    <button className='primary-btn' onClick={props.onRequestClose}>{t(RESOURCE.Myk_Label_SessionSignIn)}</button>
                    <button className='cancel-btn' onClick={props.onLogOffCall}>{t(RESOURCE.Myk_Label_SessionSignOut)}</button>
                </div>
            </div>
        </div>
    );
}

export default SessionError;